import { IRevenueSpendByAccountSpendDetailsTableLang } from '../../../types/lang'

export const revenueSpendByAccountSpendDetailsTableLang: IRevenueSpendByAccountSpendDetailsTableLang = {
	revenue_spend_by_account_spend_details_table: {
		column_id: 'ID_ua',
		column_date: 'Date_ua',
		column_amount: 'Amount_ua',
		column_percent: 'Percent, %_ua',
		column_account: 'Account_ua',
		column_kt_group: 'KT Group_ua',
		column_agency: 'Agency_ua',
		column_fake_type: 'Fake Type_ua'
	}
}